import React, { useEffect, useState } from 'react';
import './Loader.css';
import loaderImg from './../../assets/loader.png';

const Loader = () => {
  const [count, setCount] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1;
      });
    }, 20); // Speed: lower = faster

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loader-container">
      <img src={loaderImg} alt="Loading..." className="loader-image" />
      <p className="loading-text">Loading {count}%</p>
    </div>
  );
};

export default Loader;
